module.exports = __webpack_public_path__ + "img/dissatisfaction.21c93d1e.png";